import { CANAL,CANALAll } from "actions/canal";
import { reducerPackage } from "../../utils";

export const canal = reducerPackage(CANAL);
export const canalAllList = reducerPackage(CANALAll);
